import { Component, EventEmitter, OnInit, Output } from "@angular/core";

@Component({
  selector: "kl-panel",
  template: ` <kl-footer></kl-footer> `,
})
export class PanelComponent implements OnInit {
  @Output() onToggle = new EventEmitter<boolean>();
  isNavigatorCollapsed = false;

  constructor() {}

  ngOnInit() {}

  toggleNavigator() {
    this.onToggle.emit();
  }
}
